import { useState, useCallback } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StripeEmbeddedCheckout } from "@/components/StripeEmbeddedCheckout";

interface CheckoutOptions {
  priceId: string;
  purchaseType?: "premium_guide" | "digital_resource";
  entityId?: string;
  returnUrl?: string;
  title?: string;
}

export function useStripeCheckout() {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState<CheckoutOptions | null>(null);

  const openCheckout = useCallback((opts: CheckoutOptions) => {
    setOptions(opts);
    setIsOpen(true);
  }, []);

  const closeCheckout = useCallback(() => {
    setIsOpen(false);
    setOptions(null);
  }, []);

  const checkoutDialog =
    isOpen && options ? (
      <Dialog open={isOpen} onOpenChange={(o) => !o && closeCheckout()}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{options.title || "Complete your purchase"}</DialogTitle>
          </DialogHeader>
          <StripeEmbeddedCheckout
            priceId={options.priceId}
            purchaseType={options.purchaseType}
            entityId={options.entityId}
            returnUrl={options.returnUrl}
          />
        </DialogContent>
      </Dialog>
    ) : null;

  return { openCheckout, closeCheckout, isOpen, checkoutDialog };
}
